import { render, staticRenderFns } from "./createClient.vue?vue&type=template&id=dcdc10ca&scoped=true"
import script from "./createClient.vue?vue&type=script&lang=js"
export * from "./createClient.vue?vue&type=script&lang=js"
import style0 from "./createClient.vue?vue&type=style&index=0&id=dcdc10ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdc10ca",
  null
  
)

export default component.exports